<script lang="ts" setup>
import { GameCategoryEnum } from '~/enums/routes'
import type { HeaderTabItem } from '~/types/app'

const route = useRoute()
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  tabs: {
    type: Array as () => HeaderTabItem[],
    required: true,
  },
})

const activeItem = (item: HeaderTabItem): boolean => {
  const { cats = '' } = route.params
  if (cats === GameCategoryEnum.Lode || cats === GameCategoryEnum.Slots) {
    return cats === item.key
  }
  return props.modelValue.includes(item.to)
}
</script>

<template>
  <div class="header-tabs">
    <NuxtLink
      v-for="tab in props.tabs"
      :key="tab.key"
      :to="tab.to"
      :class="{
        'header-tabs__item': true,
        'header-tabs__item--active': activeItem(tab),
      }"
    >
      <div class="header-tabs__item-title">
        <i v-if="tab.icon" :class="tab.icon" />
        {{ tab.title }}
      </div>
    </NuxtLink>
  </div>
</template>
<style scoped></style>
